import { getAppServices } from "@10x/coreapp";

export function showRVPage() {
	getAppServices().navigationService.navigate( "/mydld/rentalvaluation" );
}

export function showRVRequests() {
	getAppServices().navigationService.navigate( "/mydld/rentalvaluation/requests" );
}

export function showRVRequestDetails( reqNo: string ) {
	getAppServices().navigationService.navigate( `/mydld/rentalvaluation/request/${ reqNo }` );
}
